import React, { Component } from 'react';

class PlaceMap extends Component {
  render() {
    return (
      <>
        <iframe
          id={this.props.id}
          title={this.props.title || 'Location map'}
          width="100%"
          height="250"
          style={{ border: 0 }}
          loading="lazy"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
          src={
            this.props.mapIframeEmbedUrl +
            '&key=' +
            process.env.REACT_APP_GOOGLE_MAPS_KEY +
            '&zoom=18&maptype=satellite&mapId=' +
            this.props?.mapId
          }
        ></iframe>
      </>
    );
  }
}

export default PlaceMap;
